<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const BadgeDefaults = {
        "name": "badge",

        "meta": {
            "order": {
                "badgeContainer": 0,
                "icon": 1,
                "text": 3,
            }
        },

        "outer-container": { 
            "style": {
                "padding-top": "7px",
                "padding-bottom": "7px",
                "padding-left": "7px",
                "padding-right": "7px",
                "align-items": "flex-start"
            }
        },

        "badge-container": {
            "name": "badge-container",
            "style": {
                "background-color": "rgba(0,0,0,0.15)",
                "color": "inherit",
                "padding": "5px",
                "padding-right": "20px",
                "border-radius": "100px",
                "font-size": "0.9rem",
                "display": "flex",
                "align-items": "center",
            }
        },

        "text": {
            "name": "text",
            "style": {
                "margin-bottom": "1px",
            },
            "innerText": "Here's a badge"
        },

        "icon": {
            "name": "icon",
            "style": {
                "background-color": "black",
                "width": "29px",
                "height": "29px",
                "margin-right": "10px",
                "margin-bottom": "1px",
            },
            "custom": {
                "icon": {
                    "element": "icon",
                    "value": "checkmark.circle.fill",
                    "type": "icon",
                    "style": {
                        "-webkit-mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                        "mask": "url(../static/symbols/{{value}}.svg) no-repeat center / contain",
                    }
                }
            }
        }
    }

    
    
</script>

<script>

</script>


<div data-i-name="badge-container">
    <div data-i-name="icon"/>
    <p data-i-name="text"/>
</div>

<style>


</style>